<template>
    <oc-form-field
        :target="name"
        :auto-register-field="false"
        class="oc-table-cell-input"
        v-bind="$_options"
        :input="inputType"
        v-on="$listeners"
    />
</template>

<script>
export default {
    name: 'oc-input-row-cell',
    inject: ['$source'],
    props: ['row', 'col', 'index', 'options'],
    computed: {
        $_options() {
            return Object.assign({
                displayLabel: false
            }, this.options)
        },
        name() {
            return `${this.$source.prefix}.${this.index}.${this.col.field}`
        },
        inputType() {
            return this.options.input || this.$source.defaultInputColumnType
        }
    }
}
</script>

<style scoped>
.oc-table-cell-input.form-group {
    margin-bottom: 0;
}
.oc-table-cell-input.form-group >>> .input-group {
    flex-direction: column;
}

.oc-table-cell-input.form-group >>> .input-group .form-control {
    width: 100%;
}
</style>
